import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlanSectionComponent } from './plan-section.component';
import { PlusIconModule } from '../plus-icon/plus-icon.module';
import { ConfirmationIconModule } from '../confirmation-icon/confirmation-icon.module';
import { WebButtonModule } from '../web-button/web-button.module';

@NgModule({
    declarations: [PlanSectionComponent],
    imports: [CommonModule, WebButtonModule, ConfirmationIconModule, PlusIconModule, FormsModule],
    exports: [PlanSectionComponent],
})
export class PlanSectionModule {}
